'use client';

import { usePathname } from 'next/navigation';
import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import ExpandableMenu from './expandable-menu';
import { clearSearchParams } from '@/app/lib/store/search-params-slice';
import { NAVIGATION_ITEMS_IN_ROW } from '@/app/lib/constants/sizes';

export default function ExpandableMenuContainer() {
  const pathname = usePathname();
  const currentTopicSlug = pathname.split('/').pop();

  const branches = useAppSelector(state => state.navigation.branches);

  const dispatch = useAppDispatch();

  const executeBeforeNavigation = () => {
    dispatch(clearSearchParams());
  };

  const items = branches.map(branch => ({
    ...branch,
    layoutClassName:
      branch.topics.length > NAVIGATION_ITEMS_IN_ROW
        ? 'navigationGrid'
        : 'navigationFlex'
  }));

  return (
    <ExpandableMenu
      items={items}
      currentTopicSlug={currentTopicSlug}
      onBeforeNavigate={executeBeforeNavigation}
    />
  );
}
